<template>
  <div class="statistics">
    <!-- 团队数量统计 -->
    <div class="order_counts">
      <div class="header">
        <div class="title">团队数量统计</div>
        <div class="select-time" @click="showRangTimeTop(1)">
          <span>{{ selectTime2 }}</span>
          <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
        </div>
      </div>
      <div class="cont">
        <div class="search_box">
          <div class="area_select" @click="checkArea('8')">
            <span>{{ scenicTypeText.text }}</span>
            <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
          </div>
          <div class="area_select" @click="checkArea('6')">
            <span>{{ selectAreaThree }}</span>
            <img v-if="localNum != 3" src="@/assets/image/ic_jiantou_down@2x.png" alt />
          </div>
          <div v-show="showScenic2" class="area_select scenic_select" @click="checkArea('7')">
            <span>{{ teamScenicText.text }}</span>
            <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
          </div>
        </div>
        <div class="line">
          <div class="cont_item">
            <div class="tit">预约单量(单)</div>
            <div class="counts">{{ teamsStatistics.appointNum | numSeparate }}</div>
          </div>
          <div class="cont_item">
            <div class="tit">预约人数(人次)</div>
            <div class="counts">{{ teamsStatistics.appointPeopleNum | numSeparate }}</div>
          </div>
        </div>
        <div class="line">
          <div class="cont_item">
            <div class="tit">核销单量(单)</div>
            <div class="counts">{{ teamsStatistics.checkNum | numSeparate }}</div>
          </div>
          <div class="cont_item">
            <div class="tit">实际入园人数(人次)</div>
            <div class="counts">{{ teamsStatistics.inParkNum | numSeparate }}</div>
          </div>
        </div>
        <div class="line" v-if="scenicTypeText.value == 1">
          <div class="cont_item">
            <div class="tit">符合补贴人数(人次)</div>
            <div class="counts">{{ teamsStatistics.subsidyNum | numSeparate }}</div>
          </div>
          <div class="cont_item">
            <div class="tit">符合补贴金额(元)</div>
            <div class="counts">{{ teamsStatistics.subsidyMoney | numSeparate }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 散客数量统计 -->
    <div class="order_counts">
      <div class="header">
        <div class="title">散客数量统计</div>
        <div class="select-time" @click="showRangTimeTop(2)">
          <span>{{ selectTime }}</span>
          <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
        </div>
      </div>
      <div class="cont" style="height:auto;">
        <div class="search_box">
          <div class="area_select" @click="checkArea('1')">
            <span>{{ selectAreaOne }}</span>
            <img v-if="localNum != 3" src="@/assets/image/ic_jiantou_down@2x.png" alt />
          </div>
          <div v-show="showScenic" class="area_select scenic_select" @click="checkArea('4')">
            <span>{{ selectScenic.text }}</span>
            <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
          </div>
        </div>
        <div class="line">
          <div class="cont_item">
            <div class="tit">预约单量(单)</div>
            <div class="counts">{{ statistics.appointNum | numSeparate }}</div>
          </div>
          <div class="cont_item">
            <div class="tit">预约人数(人次)</div>
            <div class="counts">{{ statistics.appointPeopleNum | numSeparate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="line_chart">
      <div class="title">未来10天预约情况</div>
      <div class="chart_contains chart_model">
        <div class="title">
          <div class="search_box">
            <div class="area_select" @click="checkArea('9')">
              <span>{{ appoinmentText.text }}</span>
              <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
            </div>
            <div class="area_select" @click="checkArea('2')">
              <span>{{ selectAreaTwo }}</span>
              <img v-if="localNum != 3" src="@/assets/image/ic_jiantou_down@2x.png" alt />
            </div>
            <div v-show="showFutureScenic" class="area_select scenic_select" @click="checkArea('3')">
              <span>{{ selectFutureScenic.text }}</span>
              <img src="@/assets/image/ic_jiantou_down@2x.png" alt />
            </div>
          </div>
        </div>
        <NoBkgLineCharts v-if="chartsData.length > 0" class="line_charts" :data="chartsData" :showYear="true"
          :color="color" :unit="unit"></NoBkgLineCharts>
      </div>
    </div>
    <!-- 团队数量统计选择器 -->
    <common-picker ref="scenicTypePicker" :typeList="scenicTypeList" :cols="colsScenic"
      @getTypeValue="getScenicType"></common-picker>
    <!-- 团队地区 -->
    <common-picker ref="teamAreaPicker" :typeList="typeListCity" :cols="colsCity"
      @getTypeValue="teamGetCityValue"></common-picker>
    <!-- 团队景区 -->
    <common-picker ref="teamScenicPicker" :typeList="teamScenicList" :cols="colsScenic"
      @getTypeValue="getScenicValue"></common-picker>
    <!-- 散客地区选择 -->
    <common-picker ref="areaPicker" :typeList="typeListCity" :cols="colsCity"
      @getTypeValue="getCityValue"></common-picker>
    <!-- 散客景区选择 -->
    <common-picker ref="scenicPicker" :typeList="typeListScenic" :cols="colsScenic"
      @getTypeValue="getScenicValue"></common-picker>
    <!-- 未来10天预约情况 -->
    <!-- 团队预约/散客预约/全部 -->
    <common-picker ref="teamAppoimentPicker" :typeList="appoinmentType" :cols="colsScenic"
      @getTypeValue="TeamAppointment"></common-picker>
    <!-- 地区 -->
    <common-picker ref="areaPicker1" :typeList="typeListCityItem" :cols="colsCityItem"
      @getTypeValue="getCityValueItem"></common-picker>
    <!-- 景区选择 -->
    <common-picker ref="scenicFuturePicker" :typeList="typeListFutureScenic" :cols="colsScenic"
      @getTypeValue="getScenicValue"></common-picker>
    <!-- 时间选择器 -->
    <rangTime ref="rangeTime" @getCurrentTime="getCurrentTime" :allowSameDay="true"></rangTime>
    <rangTime ref="rangeTime2" @getCurrentTime="getCurrentTime" :allowSameDay="true"></rangTime>
    <!-- 奖补限制时间选择器 -->
    <rangTime ref="rangeTime3" @getCurrentTime="getCurrentTime" :allowSameDay="true" :minDate="minDate"
      :maxDate="maxDate"></rangTime>
  </div>
</template>
<script>
import appointment from "../../../../../service/modules/appointment";
import commonPicker from "../../../../components/base/commonPicker";
import NoBkgLineCharts from "@/components/NoBkgLineCharts";
import rangTime from "../../../components/rangTime";
import { storageGetByName } from '../../../../../utils/helper';

export default {
  components: {
    commonPicker,
    NoBkgLineCharts,
    rangTime
  },
  data() {
    return {
      subsidyDate: {
        beginTime: '2020-05-22',
        endTime: '2020-12-31'
      },
      minDate: new Date('2020/5/22'),
      maxDate: new Date('2020/12/31'),
      teamScenicList: [], // 团队的景区列表
      isShowAbountButton: true,
      areaCode: '',
      personalAreaCode: '',
      futureAreaCode: '',
      /** areaLevel  1省,2市,3区县 */
      localNum: '',
      typeListCity: [],
      typeListCityItem: [],
      colsCity: 2,
      colsCityItem: 2, // 选择器的列数
      colsTime: 3,
      auth: '',
      regionLevel: "",
      selectArea: "全省", // 当前选中的地区
      selectAreaOne: "",
      selectAreaTwo: "",
      selectAreaThree: "",
      selectArea2: "全省",
      // 团队景区
      teamScenicText: {
        text: "选择景区",
        value: ""
      },
      // 个人景区
      selectScenic: {
        text: "选择景区",
        value: "",
      },
      // 未来景区
      selectFutureScenic: {
        text: "选择景区",
        value: "",
      },
      showScenic: false,
      showScenic2: false, // 控制团队模块景区列表显示
      showFutureScenic: false,
      oprateModel: "", // 当前操作的模块， 1为预约数量统计，2为未来10天预约情况，3为团队数量统计
      colsScenic: 1,
      typeListScenic: [], // 景区列表
      typeListFutureScenic: [],
      selectTime: "选择时间", // 当前选中的时间
      selectTime2: "选择时间",
      chartsData: [],
      color: "green",
      unit: "人",
      beginTime: "",
      endTime: "",
      personalBeginTime: "",
      personalEndTime: "",
      sumStatistics: {}, // 预约总数统计
      statistics: {}, // 预约数量统计
      predictAppoint: {}, // 未来10天预约情况
      teamsStatistics: {}, // 团队数量统计
      scenicTypeList: [
        [
          {
            value: 0,
            text: '全部景区'
          },
          {
            value: 1,
            text: '奖补景区'
          }
        ]
      ], // 景区类型：全部景区或奖补景区
      appoinmentType: [
        [
          {
            value: 1,
            text: '团队预约'
          },
          {
            value: 2,
            text: '散客预约'
          }
        ]
      ],
      rangeTimeVal: 0, // 日历选择器，1为团队的日历选择器， 2为散客的日历选择器
      scenicTypeText: {
        text: "全部景区",
        value: 0
      }, // 所选景区，全部景区或奖补景区
      appoinmentText: {
        text: "团队预约",
        value: 1
      }
    };
  },
  async created() {
    let auth = await storageGetByName('auth')
    this.areaCode = auth.areaCode
    this.personalAreaCode = auth.areaCode
    this.futureAreaCode = auth.areaCode
    this.localNum = auth.areaLevel
    this.getAllCity();
    this.queryAppointCount(true); // 获取统计的值，预约单量、预约人数等。。。。。
    this.queryAppointCount(false); // 获取统计的值，预约单量、预约人数等。。。。。
    this.queryTrend();
  },
  async beforeMount() {
    let integrityInfo = await storageGetByName('integrityInfo')
    this.auth = integrityInfo
    let auth = await storageGetByName('auth')
    this.areaCode = auth.areaCode
    this.personalAreaCode = auth.areaCode
    this.futureAreaCode = auth.areaCode
    /** areaLevel  1省,2市,3区县 */
    this.localNum = auth.areaLevel
  },
  methods: {
    /** 唤醒年月日弹窗 */
    showRangTimeTop(val) {
      this.rangeTimeVal = val;
      if (val === 2) {
        this.$refs.rangeTime.showTime();
      } else if (val === 1) {
        switch (this.scenicTypeText.value) {
          case 0:

            this.$refs.rangeTime2.showTime();
            break;
          case 1:

            this.$refs.rangeTime3.showTime();
            break;

          default:
            this.$refs.rangeTime2.showTime();
            break;
        }
      }
    },
    /** 唤醒日历弹窗 */
    showRangTime() {
      this.$refs.rangeTime.showTime();
    },
    /** 日历事件弹窗处理 */
    getCurrentTime(value) {
      if (this.rangeTimeVal === 2) {
        // 2为散客的日历选择器
        if (value) {
          this.personalBeginTime = value[0].split(" ")[0];
          this.personalEndTime = value[1].split(" ")[0];
          this.selectTime = (this.personalBeginTime + "~" + this.personalEndTime).replace(/-/g, '/');
          this.ishowRangeTime = false;
          this.queryAppointCount(true);
        } else {
          this.ishowRangeTime = false;
        }
      } else if (this.rangeTimeVal === 1) {
        this.beginTime = value[0].split(" ")[0];
        this.endTime = value[1].split(" ")[0];
        this.selectTime2 = (this.beginTime + "~" + this.endTime).replace(/-/g, '/');
        this.ishowRangeTime = false;
        this.queryAppointCount(false);
      }
    },
    // 预约总数统计
    queryAppointCount(type) {

      let params = {
        areaCode: this.areaCode,
        orgId: this.selectScenic.value,
        startDate: this.beginTime,
        endDate: this.endTime,
        isSubsidy: this.scenicTypeText.value,
        channelType: 1
      };
      if (type) {
        //散客预约为全部不分奖补
        params.isSubsidy = 0;
        params.channelType = 2;
        params.startDate = this.personalBeginTime;
        params.endDate = this.personalEndTime;
        params.areaCode = this.personalAreaCode;
        appointment.queryAppointCount(params).then(res => {
          this.statistics = res.data || {};
        });
      } else {
        params.orgId = this.teamScenicText.value;
        appointment.queryAppointCount(params).then(res => {
          this.teamsStatistics = res.data || {};
        });
      }
    },
    // 获取未来10天预约情况数据
    queryTrend() {
      let params = {
        areaCode: this.futureAreaCode,
        orgId: this.selectFutureScenic.value,
        channelType: this.appoinmentText.value
      };
      appointment.queryPredictAppoint(params).then(res => {
        this.predictAppoint = res.data;
        for (var i = 0; i < res.data.length; i++) {
          let day = res.data[i].date.substr(5);
          let num = res.data[i].appointNum + "";
          this.chartsData.push({ xAxis: day, num: num });
        }
        this.chartsData = this.chartsData;
      });
    },
    // 全部景区/奖补景区的选中回调
    getScenicType(value) {
      if (value) {
        // 仅为奖补和全部区别处理
        if (value[0].value == 1) {
          this.beginTime = this.subsidyDate.beginTime;
          this.endTime = this.subsidyDate.endTime;
          this.selectTime2 = (this.beginTime + "~" + this.endTime).replace(/-/g, '/');
        } else {
          this.beginTime = '';
          this.endTime = '';
          this.selectTime2 = '选择时间';

        }
        this.scenicTypeText = value[0];
      };
      this.queryAppointCount(false);
    },
    // 未来10天模块的团队预约选中回调
    TeamAppointment(value) {
      this.appoinmentText = value[0];
      this.chartsData = []; /** 数据重置 */
      this.queryTrend();


    },
    // 数量统计选择地区回调(散客统计)
    getCityValue(value) {
      this.selectScenic = {
        text: "选择景区",
        value: "",
      };
      if (value && value.length > 1) {
        // value[0]为一级地区的名称，如云南省，value[1]为二级地区的名称，如xx州
        if (value[1].text === "--") {
          this.selectAreaOne = value[0].text;
          this.personalAreaCode = value[0].value;
          this.showScenic = false;
        } else {
          this.selectAreaOne = value[1].text;
          this.personalAreaCode = value[1].value;
          this.querySenics(value[1].value);
          if (value[1].value.substring(4, 6) == "00") {
            this.showScenic = false;
          } else if (!(value[1].value.substring(4, 6) == "00")) {
            this.showScenic = true;
          }
        }
      } else if (value && value.length === 1) {
        this.selectAreaOne = value[0].text;
        this.personalAreaCode = value[0].value;
        this.querySenics(value[0].value);
        this.oprateModel === "1"
          ? (this.showScenic = false)
          : (this.showScenic = true);
        this.oprateModel === "2"
          ? (this.showFutureScenic = false)
          : (this.showScenic = true);
      }
      this.statistics = {}; /** 数据重置 */
      if (this.oprateModel === "1") {
        this.queryAppointCount(true); // 原来获取散客预约的
      } else if (this.oprateModel === "2") {
        this.queryTrend(); // 获取未来十天的
      }
    },
    // 选中景区回调
    getScenicValue(value) {
      if (this.oprateModel === "1") {
        this.selectScenic = value[0];
        this.queryAppointCount(true);
      } else if (this.oprateModel === "2") {
        this.selectFutureScenic = value[0];
        this.queryTrend();
      } else if (this.oprateModel === "3") {
        // 团队统计
        this.teamScenicText = value[0];
        this.queryAppointCount(false);
      }
    },
    // 10天预约 地区回调
    getCityValueItem(value) {
      this.selectFutureScenic = {
        text: "选择景区",
        value: "",
      };
      if (value && value.length > 1) {
        if (value[1].text === "--") {
          this.selectAreaTwo = value[0].text;
          this.futureAreaCode = value[0].value;
          this.showFutureScenic = false;
        } else {
          this.selectAreaTwo = value[1].text;
          this.futureAreaCode = value[1].value;
          if (value[1].value.substring(4, 6) == "00") {
            this.showFutureScenic = false;
          } else if (!(value[1].value.substring(4, 6) == "00")) {
            this.showFutureScenic = true;
          }
          this.querySenics(value[1].value);
        }
      } else if (value && value.length === 1) {
        this.selectAreaTwo = value[0].text;
        this.futureAreaCode = value[0].value;
        this.querySenics(value[0].value);
      }
      this.chartsData = []; /** 数据重置 */
      this.queryTrend();
    },
    // 团队统计选择地区回调
    teamGetCityValue(value) {
      this.teamScenicText = {
        text: '选择景区',
        value: ''
      }
      if (value && value.length > 1) {
        // value[0]为一级地区的名称，如云南省，value[1]为二级地区的名称，如xx州
        if (value[1].text === "--") {
          this.selectAreaThree = value[0].text;
          this.areaCode = value[0].value;
          this.showScenic2 = false;
        } else {
          this.selectAreaThree = value[1].text;
          this.areaCode = value[1].value;
          this.querySenics(value[1].value);
          if (value[1].value.substring(4, 6) == "00") {
            this.showScenic2 = false;
          } else if (!(value[1].value.substring(4, 6) == "00")) {
            this.showScenic2 = true;
          }
        }
      } else if (value && value.length === 1) {
        this.selectAreaThree = value[0].text;
        this.areaCode = value[0].value;
        this.querySenics(value[0].value);
        this.oprateModel === "1"
          ? (this.showScenic2 = false)
          : (this.showScenic2 = true);
        this.oprateModel === "2"
          ? (this.showFutureScenic = false)
          : (this.showScenic2 = true);
      }
      this.getScenicType();
      if (this.oprateModel === "1") {
        this.queryAppointCount(true); // 原来获取散客预约的
      } else if (this.oprateModel === "2") {
        this.queryTrend(); // 获取未来十天的
      }
    },
    // 点击下拉选择地域
    checkArea(type) {
      if (this.localNum === 1) {
        this.resetAllCity();
      }
      if (type === "1" && this.localNum != 3) {
        // localNum不是3的时候可以选择地区
        this.oprateModel = "1";
        this.$refs.areaPicker.showPicker();
      } else if (type === "2" && this.localNum != 3) {
        this.oprateModel = "2";
        this.$refs.areaPicker1.showPicker();
      } else if (type === "3") {
        this.oprateModel = "2";
        this.selectFutureScenic = {
          text: "选择景区",
          value: "",
        };
        this.$refs.scenicFuturePicker.showPicker();
      } else if (type === "4") {
        this.oprateModel = "1";
        this.selectScenic = {
          text: "选择景区",
          value: "",
        };
        this.$refs.scenicPicker.showPicker();
      } else if (type === "6" && this.localNum != 3) {
        this.oprateModel = "3";
        this.$refs.teamAreaPicker.showPicker();
      } else if (type === "7") {
        this.oprateModel = "3";
        this.$refs.teamScenicPicker.showPicker();
      } else if (type === "8") {
        this.oprateModel = "3";
        this.$refs.scenicTypePicker.showPicker();
      } else if (type === '9') {
        this.oprateModel = "2"
        this.$refs.teamAppoimentPicker.showPicker();
      }
    },
    // 根据code获取景区列表
    querySenics(code) {
      appointment.scenic({ areaCode: code }).then(res => {
        if (res.ret === 0) {
          let childArr = res.data
            ? res.data.map(
              ({ name, areaCode, id }) => {
                return {
                  text: name,
                  value: id,
                  id
                };
              }
            )
            : [];
          let obj = [
            {
              text: "--",
              value: "",
              id: ""
            }
          ];
          childArr = [...obj, ...childArr];
          if (this.localNum === 3) {
            this.typeListScenic = [];
            this.typeListFutureScenic = [];
            this.teamScenicList = [];
            this.typeListScenic.push(childArr);
            this.typeListFutureScenic.push(childArr);
            this.teamScenicList.push(childArr);

            this.showScenic = true;
            this.showScenic2 = true;
            this.showFutureScenic = true;
            return;
          }
          switch (this.oprateModel) {
            case '1':
              this.typeListScenic = [];
              this.typeListScenic.push(childArr);
              break;

            case '2':
              this.typeListFutureScenic = [];
              this.typeListFutureScenic.push(childArr);
              break;

            case '3':
              this.teamScenicList = [];
              this.teamScenicList.push(childArr);
              break;
          }
        }
      });
    },
    resetAllCity() {
      this.typeListCity[0][0].children = [
        {
          text: "--",
          value: "",
          shortName: "",
          children: [
            {
              text: "--",
              value: "",
              shortName: "",
            }
          ]
        }
      ]
    },
    // 获取城市
    getAllCity() {
      appointment.city({ areaCode: this.areaCode }).then(res => {
        if (this.localNum === 1) {
          res.data[0].shortName = res.data[0].shortName == '云南省' ? '全省' : res.data[0].shortName
          res.data[0].fullName = res.data[0].fullName == '云南省' ? '全省' : res.data[0].fullName
          this.selectAreaOne = res.data[0].shortName;
          this.selectAreaTwo = res.data[0].shortName;
          this.selectAreaThree = res.data[0].shortName;
          this.colsCity = 2;
          this.colsCityItem = 2;
          let obj = {
            text: res.data[0].fullName,
            value: res.data[0].areaCode,
            shortName: res.data[0].shortName,
            children: [
              {
                text: "--",
                value: "",
                shortName: "",
                children: [
                  {
                    text: "--",
                    value: "",
                    shortName: "",
                  }
                ]
              }
            ]
          };
          let arr = res.data[0].children.map(
            ({ fullName, areaCode, shortName, children }) => {
              return {
                text: shortName || fullName,
                value: areaCode,
                shortName,
                children: children
                  ? children.map(
                    ({ fullName, areaCode, shortName, children }) => {
                      return {
                        text: shortName || fullName,
                        value: areaCode,
                        shortName,
                        children: children
                          ? children.map(
                            ({ fullName, areaCode, shortName }) => {
                              return {
                                text: shortName || fullName,
                                value: areaCode,
                                shortName
                              };
                            }
                          )
                          : []
                      };
                    }
                  )
                  : []
              };
            }
          );
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].children) {
              let cityChild = [
                { text: "--", value: "", shortName: "" }
              ];
              let newArr = arr[i].children.concat([]);
              arr[i].children = cityChild.concat(newArr);

              for (var j = 0; j < (arr[i] && arr[i].children).length; j++) {
                if (arr[i].children[j] && arr[i].children[j].children) {
                  let cityChildren = [
                    { text: "--", value: "", shortName: "" }
                  ];
                  let newArrTwo =
                    arr[i].children[j] && arr[i].children[j].children
                      ? arr[i].children[j].children.concat([])
                      : [];
                  arr[i].children[j].children = cityChildren.concat(newArrTwo);
                }
              }
            }
          }
          arr.unshift(obj);
          this.typeListCity = [];
          this.typeListCity.push(arr);
          this.typeListCityItem = [];
          this.typeListCityItem.push(arr);
        } else if (this.localNum === 2) {
          this.cols = 2;
          this.colsCity = 2;
          this.colsCityItem = 2;
          this.selectAreaOne = res.data[0].shortName;
          this.selectAreaTwo = res.data[0].shortName;
          this.selectAreaThree = res.data[0].shortName;
          let brr = [];
          brr.push(res.data[0]);
          brr = brr.map(({ fullName, areaCode, shortName, children }) => {
            return {
              text: shortName || fullName,
              value: areaCode,
              shortName: shortName,
              children: children
                ? children.map(({ fullName, areaCode, shortName }) => {
                  return {
                    text: shortName || fullName,
                    value: areaCode,
                    shortName
                  };
                })
                : []
            };
          });
          for (var j = 0; j < brr.length; j++) {
            if (brr[j].children) {
              let cityChild = [
                {
                  text: "--",
                  value1: "--",
                  regionType: ""
                }
              ];
              let newArr = brr[j].children.concat([]);
              brr[j].children = cityChild.concat(newArr);
            }
          }
          this.typeListCity = [];
          this.typeListCity.push(brr);
          this.typeListCityItem = [];
          this.typeListCityItem.push(brr);
        } else if (this.localNum === 3) {
          this.querySenics(JSON.parse(localStorage.getItem("auth")).areaCode);
          // this.colsCity = 1;
          // this.colsCityItem = 1;
          this.selectAreaOne = res.data[0].shortName;
          this.selectAreaTwo = res.data[0].shortName;
          this.selectAreaThree = res.data[0].shortName;
          // let crr = res.data[0].children.map(
          //   ({ fullName, areaCode, shortName, children }) => {
          //     return {
          //       text: shortName || fullName,
          //       value: areaCode,
          //       shortName: shortName,
          //       children: children
          //     };
          //   }
          // );
          // this.typeListCity = [];
          // this.typeListCity.push(crr);
          // this.typeListCityItem = [];
          // this.typeListCityItem.push(crr);
          this.querySenics(res.data[0].areaCode);
          // this.typeListFutureScenic.push(crr);
          // this.typeListScenic.push(crr);
        }
      });
    },
  },
  filters: {
    numSeparate(value) {
      var rag = /(\d)(?=(?:\d{3})+$)/g;
      if (!value) {
        return "0";
      } else {
        if ((value + "").indexOf('.') != -1) {
          let num = value.toString().split('.');
          return num[0].replace(rag, "$1,") + '.' + num[1];
        }
        return (value + "").replace(rag, "$1,");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.statistics {
  background-color: #fbfbfb;
  padding: 40px 12px 48px 12px;
}

.order_quantum {
  margin-top: 18px;
}

.line_chart {
  margin-bottom: 24px;
}

.line_chart>.title {
  margin-bottom: 12px;
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.order_quantum .title {
  margin-top: 18px 24px;
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.order_quantum .cont {
  margin: 12px 0;
  width: 351px;
  // height: 300px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
}

.header {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
  margin-bottom: 12px;
}

.line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 200%;
    height: 1px;
    background-color: #eeeeee;
    transform: scale(0.5);
    bottom: 0;
    left: -50%;
  }
}

.line:last-child {
  border: 0;

  &:after {
    width: 0;
  }
}

.cont_item {
  width: 175px;
  text-align: center;
}

.cont_item .tit {
  margin-top: 24px;
  font-size: 12px;
  color: #333;
}

.cont_item .counts {
  margin: 8px 0 24px;
  color: #36b374;
  font-size: 24px;
  font-weight: bold;
}

.order_counts {
  margin: 24px 0;
}

.order_counts .cont {
  // width: 351px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
}

.header .title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.header img {
  display: inline-block;
  width: 6px;
  height: 4px;
  vertical-align: middle;
}

.header .select-time {
  margin-left: 10px;
  display: flex;
  align-items: center;

  span {
    margin-right: 4px;
    font-size: 12px;
    color: #666;
  }
}

.search_box {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 200%;
    height: 1px;
    background-color: #eeeeee;
    transform: scale(0.5);
    bottom: 0;
    left: -50%;
  }
}

.area_select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 4px;
  flex-shrink: 0;
}

.area_select img {
  display: inline-block;
  width: 6px;
  height: 4px;
  vertical-align: middle;
}

.area_select span {
  display: inline-block;
  margin-right: 4px;
  font-size: 12px;
  color: #666;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scenic_select {
  flex-shrink: 1;
}

.chart_model {
  width: 351px;
  height: 288px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
}

.line_charts {
  height: 244px;
}
</style>
<style lang="scss">
.statistics .md-popup-mask {
  background-color: rgba(37, 38, 45, 0.3);
}

.statistics .van-button {
  border-radius: 3px;
  height: 40px;
  font-size: 16px;
}
</style>